import React from "react";
import Navbar from "../components/navbar";
import { Link } from "react-router-dom";
import Footer from "../components/footer";
import Prayer from "../components/prayer";
import backgroundImage from "../assets/backabout.jpg";
import "../styles/about.css";
import speakerImage from "../assets/preach.jpg";
import Read from "../assets/read.jpg";
import withScroll from "../components/scroll";
import { Helmet } from "react-helmet";

const About = ({ sectionRef, handleScroll }) => {
  return (
    <div className="about-page">
      <Helmet>
        <title>About Us — Calvary First Nigerian SDA Church</title>
      </Helmet>
      <Navbar />
      <main>

        {/* ── Hero ── */}
        <section
          className="about-hero"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="about-hero-content">
            <h1>
              What do you
              <br />
              know about us?
            </h1>
          </div>
          <div className="about-hero-buttons">
            <button className="about-btn" onClick={handleScroll}>
              Read about us
            </button>
            <Link to="/contact" className="about-btn about-btn-secondary">
              Reach out to us
            </Link>
          </div>
        </section>

        {/* ── Pastor's message ── */}
        <section ref={sectionRef} className="about-message">
          <div className="about-pastor-img">
            <img src={speakerImage} alt="Church Pastor" />
          </div>
          <div className="about-message-text">
            <span className="about-msg-tag">From the Pastor</span>
            <h2>Greetings from Church Pastor</h2>
            <p>
              Welcome to our CFNSDAC website, the finest digital sanctuary and
              spiritual oasis. You have discovered the center of innovation,
              diversity, and inclusivity. This platform was designed to
              stimulate creativity, imagination, and spiritual growth for all
              our prestigious users including you. We are delighted to have you
              as a part of our community. As a Christian community with a
              passionate mission for the world, we are delighted to serve all
              people, particularly, minority- rejected, marginalized, forgotten,
              and maligned groups. We are here to genuinely assist you at every
              stage of your journey. So, feel free to discover, interact, and
              collaborate with us to create the amazing experience and reality
              you have been seeking. You may drop a request for prayer in the
              section marked "Prayer Request Basket." You may also make a
              request for visitation and your contact details, and our pastoral
              team will contact you as soon as possible.
            </p>
          </div>
        </section>

        {/* ── Church history ── */}
        <section className="about-history">
          <div className="about-history-head">
            <h2>About Calvary First Nigerian SDA Church</h2>
            <blockquote className="about-scripture">
              <p>
                "Train up a child in the way he should go, and when he is old,
                he will not depart from it."
              </p>
              <cite>Proverbs 22:6</cite>
            </blockquote>
          </div>

          <div className="about-history-body">
            <p>
              Most of the members that comprise the Calvary S.D.A. Church are
              people who have been raised and nurtured in Adventist homes and
              educational institutions from home. However, upon reaching this
              country, because of the societal pressures and influences, most of
              us did not join any church, attending church sporadically, some
              attending church and some joined completely stopped non-Adventist
              churches. But the truth within and the indwelling spirit was too
              strong to ignore.
            </p>
            <p>
              It was under the above setting that the Almighty God put together
              the Calvary SDA Church. I was sitting in my living room one
              fateful evening when the phone rang, it was brother Ephraim
              Ajibade. "I have been thinking — why can't we come together and
              form a church?" Of course, my answer was an enthusiastic "yes."
              A meeting date was set for May 21, 1989, attended by 11 founding
              members.
            </p>
            <p>
              On a bright Saturday morning June 3, 1989, a group of 40 adults
              and children gathered at 800 Rogers Avenue to hold the first
              service of a congregation that would later be known as Calvary
              S.D.A. Church. Our first hymn of worship was #340 "Jesus Saves."
            </p>
            <p>
              The experience of Calvary Church has been unique — a congregation
              put together by God's own Providence, nurtured and sustained by
              His awesome power. Through the years, through all our ups and
              downs, we have seen the evidence of God's controlling power. God
              has been faithful to us.
            </p>
            <p>
              After many years of searching for a permanent home, God led us to
              Lexington Avenue. We gathered in front of 778, held hands, and
              petitioned the Almighty to give us these properties — and He did.
              We moved into our building on May 6, 2000, and it was dedicated
              on June 24, 2000.
            </p>
            <p>
              As we look back and remember the many good things the Lord has
              been able to do for us and through us as a congregation, we are
              encouraged to boldly face the future with confidence and hope.
              Our membership, youth, and children inclusive, stands at about
              120. We will prayerfully forge ahead until we have fulfilled our
              commission here in Bedford Stuyvesant, then in Brooklyn, and in
              the state and country as a whole.
            </p>
            <p>
              The name chosen and approved by the Conference Administration is
              "First Nigerian Seventh-Day Adventist Church." As this
              congregation's status changed from Mission to full-fledged church,
              its name simultaneously changed from Calvary Mission to First
              Nigerian Seventh-Day Adventist.
            </p>
          </div>
        </section>

        {/* ── Mission ── */}
        <section className="about-mission">
          <h2>Our Local Church Mission</h2>
          <p>
            Welcome to our cherished sanctuary of love and worship. Amongst
            God's family, find solace, strength, and belonging. We rejoice in
            your presence, knowing that together, we journey in faith and love.
          </p>
        </section>

        {/* ── Beliefs ── */}
        <section
          className="about-belief"
          style={{ backgroundImage: `url(${Read})` }}
        >
          <div className="about-belief-content">
            <h2>Our Fundamental Beliefs</h2>
            <p>
              Wondering what we believe, and why we worship the way we do?
            </p>
            <a
              href="https://www.adventist.org/beliefs/"
              target="_blank"
              rel="noopener noreferrer"
              className="about-belief-btn"
            >
              See our beliefs →
            </a>
          </div>
        </section>

        <Prayer />
      </main>
      <Footer />
    </div>
  );
};

export default withScroll(About);